import axios from '@/libs/api.request'
// 查询协议列表
export const getAgreemenList = data => {
  return axios.request({
    url: '/agreement/list',
    data,
    method: 'POST'
  })
}
// 获取协议详情
export const getAgreemenDetail = data => {
  return axios.request({
    url: '/agreement/detail',
    data,
    method: 'POST'
  })
}
// 查看协议
export const seeAgreemenDetail = agreementId => {
  return axios.request({
    url: '/agreement/contract/qiyuesuo/view-url/' + agreementId,
    method: 'GET'
  })
}
